/*
*   @site           Preloaded: Site
*   @function       Item Controller
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------

//-----------------------------------------------
// Class Definition
//-----------------------------------------------
class _ItemController {

  //-----------------------------------------------
  // Constructor
  //-----------------------------------------------
  constructor() {
    //Lists
    this.lists = {
      flexTitle: []
    };
  }


  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Pull a list of items
    let list = document.querySelectorAll('.item-index, .item-standard');
    for(let i = 0; i < list.length; i++) {
      //Look for a flexible height element
      let title = list[i].querySelector('.flex-height');
      if(title) {
        this.lists.flexTitle.push({
          element: list[i],
          title: title
        });
      }
    }

    //Loop through
    this.setTitleHeights();
  }


  //-----------------------------------------------
  // Set title heights (only on blog index and 444 blog module
  //-----------------------------------------------
  setTitleHeights() {
    if(this.lists.flexTitle.length) {
      //Vars
      let maxHeight = 0;
      let lastY;
      let rowItems = [];
      let bounds;
      let rowThreshold = 10; //px difference to detect a new row (accounts for rounding and any weirdness with browsers)

      //Reset to auto height
      for(let i = 0; i < this.lists.flexTitle.length; i++) {
        this.lists.flexTitle[i].title.style.height = 'auto';
      }

      //Do we need a pause here, to ensure everything has reset position?

      //Loop
      for(let i = 0; i < this.lists.flexTitle.length; i++) {
        if(!this.lists.flexTitle[i].element.classList.contains('hidden')) {
          //Bounds for this item
          bounds = this.lists.flexTitle[i].title.getBoundingClientRect();

          //New row
          if(!lastY || Math.abs(lastY - bounds.y) > rowThreshold) {
            //NEW row

            //Close old row
            if(rowItems.length > 0) {
              this.closeTitleRow(rowItems, maxHeight);
            }

            //Store new row
            rowItems = [i];
            maxHeight = bounds.height;
            lastY = bounds.y;
          } else {
            //SAME row
            rowItems.push(i);
            maxHeight = Math.max(Math.ceil(bounds.height), maxHeight);
          }
        }
      }

      //Close the final row
      if(rowItems.length > 0) {
        this.closeTitleRow(rowItems, maxHeight);
      }
    }
  }


  //-----------------------------------------------
  // Close 
  //-----------------------------------------------
  closeTitleRow(list, height) {
    for(let i = 0; i < list.length; i++) {
      this.lists.flexTitle[list[i]].title.style.height = height + 'px';
    }
  }





  //-----------------------------------------------
  // Item In View
  //-----------------------------------------------
  itemInView() {
    
  }

}


//--------------------------------------------------------------------------
//  Export
//--------------------------------------------------------------------------
const ItemController = new _ItemController();
export default ItemController;